"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTitleSubmit = void 0;
const slate_1 = require("slate");
/**
 * Editor enhancer that fires `getOnSubmit()(titleText)` when the user
 * presses Enter while the caret is at the **end** of a `title` block.
 *
 * The callback is read through a getter on every break so callers can
 * update it on each render (via a ref) without recreating the editor.
 */
const withTitleSubmit = (editor, getOnSubmit) => {
    const { insertBreak } = editor;
    editor.insertBreak = () => {
        let titleText;
        const onSubmit = getOnSubmit();
        const selection = editor.selection;
        if (onSubmit && selection && slate_1.Range.isCollapsed(selection)) {
            const match = slate_1.Editor.above(editor, {
                at: selection,
                match: (node) => slate_1.Element.isElement(node) && node.type === 'title',
                mode: 'lowest',
            });
            if (match) {
                const [titleNode, titlePath] = match;
                if (slate_1.Editor.isEnd(editor, selection.anchor, titlePath)) {
                    titleText = slate_1.Node.string(titleNode);
                }
            }
        }
        insertBreak();
        if (titleText !== undefined && onSubmit)
            onSubmit(titleText);
    };
    return editor;
};
exports.withTitleSubmit = withTitleSubmit;
